/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-19 17:51:46
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-13 21:02:41
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Query1/Filter/SingleSelection/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import { Empty } from 'antd';
import { Input, Menu, MenuItem } from 'src/components/Antd';
import DropDown from '../DropDown';
import { getLabel } from '../tools';

const SingleSelection = (props) => {
  const {
    keyWord,
    value: selected,
    options: o = [],
    onConfirm,
    onDropDownChange,
    sortedByFirstLetter = true,
    searchable,
  } = props;
  const [search, setSearch] = React.useState('');

  const options = sortedByFirstLetter
    ? o.sort(function (a, b) {
        return (a.label + '').localeCompare(b.label + '');
      })
    : o;
  const _options = React.useMemo(() => {
    if (!search) {
      return options;
    } else {
      const o = options.filter((i) => {
        const _search = search.toLocaleLowerCase();
        const _label = i.label.toLocaleLowerCase();
        return _label.indexOf(_search) > -1;
      });
      return o;
    }
  }, [search, options]);
  const handleOnConfirm = (key) => {
    const { selectedKeys = [] } = key;
    if (onConfirm) {
      onConfirm({
        [keyWord]: getLabel(selectedKeys, options),
      });
    }
    onDropDownChange(false);
  };

  return (
    <div className={css.container}>
      {searchable && (
        <Input
          size='small'
          className={css.input}
          onChange={setSearch}
          value={search}
        />
      )}
      {_options.length > 0 ? (
        <Menu onSelect={handleOnConfirm} selectedKeys={selected}>
          {_options.map((menu) => {
            const { value, label } = menu || {};

            return (
              <MenuItem className={css.subMenu} key={value}>
                {label}
              </MenuItem>
            );
          })}
        </Menu>
      ) : (
        <Empty />
      )}
    </div>
  );
};

export default DropDown(SingleSelection, {
  name: 'Range',
});
